import React, { FC } from 'react';
import { LocationOn as LocationOnIcon } from '@mui/icons-material';

const MapPin: FC = () => {
  return <LocationOnIcon color="secondary" fontSize="large" />;
};

export default MapPin;
